import React from 'react'
import Card from 'react-bootstrap/Card'
import Image from 'react-bootstrap/Image'
import Button from 'react-bootstrap/Button'
import { Navigate, useNavigate } from 'react-router-dom'
import { CLASSES } from '../../assets/styles/styles'
import { IMAGE_URL } from '../../utils/constants'

function ProductCard({ item }) {
  const navigate = useNavigate()
  const placeholder = 'https://placehold.co/300'
  const [imgSrc, setImgSrc] = React.useState(
    item?.thumbnail ? `${IMAGE_URL + item?.thumbnail}` : placeholder,
  )

  const handleImageError = () => {
    setImgSrc(placeholder)
  }
  const imageBackground = 'gray'

  const descriptionStyle = {
    display: '-webkit-box',
    WebkitLineClamp: 2,
    WebkitBoxOrient: 'vertical',
    overflow: 'hidden',
  }

  return (
    <Card
      border='0'
      className={'position-relative pointer h-100'}
      onClick={() => navigate(`/products/view/${item.id}`, { state: item })}
    >
      <Card.Body className='d-flex flex-column justify-content-between'>
        <div
          style={{
            width: '100%',
            aspectRatio: 1 / 1,
            position: 'relative',
            backgroundColor: 'white',
            // borderRadius: 10,
            overflow: 'hidden',
          }}
          className={CLASSES.content_center}
        >
          <Image
            style={{
              backgroundColor: item?.thumbnail?.includes('.png')
                ? 'white'
                : imageBackground,
              height: '100%',
              width: '100%',
            }}
            className='text-center'
            src={imgSrc}
            alt={item.name}
            onError={handleImageError}
          />
        </div>

        <div className='p-3'>
          <p
            onClick={() =>
              navigate(`/products/view/${item.id}`, { state: item })
            }
            style={{ fontWeight: 600, ...descriptionStyle }}
            className='m-0 text-center text-success mb-3 pointer'
          >
            {item.name}
          </p>
          <div
            style={descriptionStyle}
            dangerouslySetInnerHTML={{ __html: item.description }}
            className='mt-1 text-center dangerouslySetInnerHTML text-secondary product-description'
          />
        </div>
        <div className={CLASSES.content_center}>
          <Button
            variant='outline-success'
            style={{ borderRadius: 0 }}
            onClick={() =>
              navigate(`/products/view/${item.id}`, { state: item })
            }
          >
            Learn More +
          </Button>
        </div>
      </Card.Body>
    </Card>
  )
}

export default ProductCard
